module.exports = __webpack_public_path__ + "static/media/estilo5.dfa26b4b.png";